import React, { PureComponent } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { wire } from 'react-hot-wire';
import { NavLink } from 'react-router-dom';

import Info from '../../../Info';

export class OAuthCallbackComponent extends PureComponent {
	state = {
		error: null,
	};

	render() {
		const { error } = this.state;
		const { intl } = this.props;

		if (!error) {
			return (
				<h2>
					<FormattedMessage id="auth.login.integration.oauth.loading" />
				</h2>
			);
		}

		const returnLink = (
			<NavLink to="/auth/login">{intl.formatMessage({ id: 'auth.login.integration.oauth.return' })}</NavLink>
		);

		if (error === 'user-suspended') {
			const customMessage = this.props['services.applicationService'].settings().suspendedUserCustomMessage();

			if (customMessage) {
				return (
					<Info
						title={intl.formatMessage({ id: 'auth.login.integration.oauth.error.title' })}
						message={customMessage}
						additional={returnLink}
					/>
				);
			}
		}

		return (
			<Info
				title={intl.formatMessage({
					id: `auth.login.integration.oauth.error.type.${error}`,
				})}
				message={returnLink}
			/>
		);
	}

	UNSAFE_componentWillMount() {
		const { id, code, state } = this.props;

		this.props['services.OAuthIntegrationService']
			.authorizeCallback({ id, code, state })
			.catch(error => this.setState({ error }));
	}
}

export default injectIntl(
	wire(['services.OAuthIntegrationService', 'services.applicationService'], OAuthCallbackComponent)
);
